(() => {
  const LOYALTY_MARKER = '(program lojalnościowy)';

  const getItemTitle = (item) =>
    String(
      (item?.properties && item.properties._yk_title_clean) ||
        (item?.has_components ? item?.title : item?.product_title) ||
        ''
    );

  const isLoyaltyItem = (item) => getItemTitle(item).toLowerCase().includes(LOYALTY_MARKER);

  const hideLoyaltyQuantityWidgets = () => {
    const items = window.Rebuy?.SmartCart?.cart?.items;
    if (!Array.isArray(items) || items.length === 0) return;

    items.forEach((item) => {
      const key = item?.key;
      if (!key) return;

      const widgets = document.querySelectorAll(
        `.rebuy-cart__flyout-item[data-item-key="${key}"] .rebuy-cart__flyout-item-quantity-widget`
      );
      widgets.forEach((widget) => {
        widget.style.display = isLoyaltyItem(item) ? 'none' : '';
      });
    });
  };

  const scheduleRender = () => {
    window.requestAnimationFrame(() => {
      setTimeout(hideLoyaltyQuantityWidgets, 30);
    });
  };

  document.addEventListener('rebuy:cart.ready', scheduleRender);
  document.addEventListener('rebuy:cart.change', scheduleRender);
  document.addEventListener('rebuy:cart.enriched', scheduleRender);
  document.addEventListener('rebuy:smartcart.show', scheduleRender);
})();
